import React from "react";

const ExplorePage = ({ children }) => {
  return <div className="bg-[#0f0f0f] lg:ml-60 pt-16">{children}</div>;
};

export default ExplorePage;
